import React, { Component } from 'react'
import styled from 'styled-components'
import Question from './Question'
import { graphql, compose, withApollo } from 'react-apollo'
import CreateBankCommentary from '../../queries/CreateBankCommentary'
import UpdateBankCommentary from '../../queries/UpdateBankCommentary'
import CreateReply from '../../queries/CreateReply'
import UpdateReply from '../../queries/UpdateReply'
import Modal from '../../../common/Modal'
import DeleteCommentryConfirmationModal from '../../modals/DeleteCommentryConfirmationModal'

const Container = styled.div`
  margin-bottom: 40px;
`
const Header = styled.div`
  display: flex;
  justify-content: space-between;
`
const Title = styled.div`
  height: 19px;
  width: 90px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
  text-transform: capitalize;
`
const AddNewQuestionButton = styled.div`
  display: flex;
  height: 19px;
  color: #3399CC;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  cursor: pointer;
`

class Comment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      questions: props.data,
      isDeleteModalOpen: false,
      deleteQuestionId: null,
      deleteReplyId: null,
    }
  }

  componentWillReceiveProps({ data }) {
    if (data !== undefined && data.length != 0) {
      this.setState({
        ...this.state,
        questions: data,
      })
    }
  }

  onSaveNewQuestion = ({ state, editorContent, files }) => {
    const { createBankCommentary, loanId, category } = this.props
    const { questions } = this.state

    return createBankCommentary({
      variables: {
        input: {
          loanId,
          category,
          content: editorContent,
          state,
          files
        }
      },
      update: async (store, { data: { createBankCommentary: { bankCommentary } } }) => {
        questions[questions.length - 1] = bankCommentary
        this.updateQuestions(questions)
      }
    })
  }

  onUpdateExistingQuestion = ({ rid, state, editorContent, files, deleteFiles }) => {
    const { updateBankCommentary } = this.props
    const { questions } = this.state

    const newFiles = files?.filter(file => file instanceof File) || []

    return updateBankCommentary({
      variables: {
        input: {
          bankCommentaryId: rid,
          content: editorContent,
          state,
          files: newFiles,
          deleteFiles,
        }
      },
      update: async (store, { data: { updateBankCommentary: { bankCommentary } } }) => {
        questions.map((question, index) => {
          if (question.rid === bankCommentary.rid) {
            questions[index] = bankCommentary
          }
        })
        this.updateQuestions(questions)
      }
    })
  }

  onNewReply = ({ rid, draft, editorContent, files }) => {
    const { createReply} = this.props
    const { questions } = this.state

    return createReply({
      variables: {
        input: {
          bankCommentaryId: rid,
          content: editorContent,
          draft,
          files
        }
      },
      update: async (store, { data: { createReply: { reply } } }) => {
        questions.map((question) => {
          if (question.rid === reply.bankCommentary.rid) {
            question.replies.push(reply)
          }
        })
        this.updateQuestions(questions)
      }
    })
  }

  onUpdateReply = ({ rid, draft, editorContent, files, deleteFiles }) => {
    const { updateReply} = this.props
    const { questions } = this.state

    return updateReply({
      variables: {
        input: {
          replyId: rid,
          content: editorContent,
          draft,
          files,
          deleteFiles
        }
      },
      update: async (store, { data: { updateReply: { reply } } }) => {
        questions.map((question) => {
          if (question.rid === reply.bankCommentary.rid) {
            question.replies.map((item, index) => {
              if (item.rid === reply.rid){
                question.replies[index] = reply
              }
            })
          }
        })
        this.updateQuestions(questions)
      }
    })
  }

  onDeleteReply = ({ replyId }) => {
    this.toggleDeleteModal()
    this.setState({
      deleteReplyId: replyId,
      deleteQuestionId: null,
    })
    this.renderDeleteConfirmation()
  }

  renderQuestions = questions => {
    const { isBankUser, currentAdminId } = this.props

    return (
      questions.map((question, index) => {
        return (
          <Question
            key={index}
            data={question}
            isBankUser={isBankUser}
            currentAdminId={currentAdminId}
            onCloseClick={this.onCloseClick}
            onSaveNew={this.onSaveNewQuestion}
            onUpdateExisting={this.onUpdateExistingQuestion}
            onDeleteQuestion={this.onDeleteQuestion}
            onNewReply={this.onNewReply}
            onUpdateReply={this.onUpdateReply}
            onDeleteReply={this.onDeleteReply}
          />)
      })
    )
  }

  updateQuestions = questions => {
    this.setState({
      ...this.state,
      questions,
    })
  }

  addNewQuestion = () => {
    const { questions } = this.state
    const newQuestion = {
      rid: null,
      state: 'draft',
      category: this.props.title,
      content: "",
      createdAt: null,
      document: {
        files: [],
        fileUrls: [],
      },
      replies: []
    }
    questions.push(newQuestion)
    this.updateQuestions(questions)
  }

  onCloseClick = () => {
    const newQuestions = this.state.questions.filter(({ rid }) => rid !== null )
    this.updateQuestions(newQuestions)
  }

  onDeleteQuestion = rid => {
    this.toggleDeleteModal()
    this.setState({
      deleteQuestionId: rid,
      deleteReplyId: null,
    })
    this.renderDeleteConfirmation()
  }

  toggleDeleteModal = () => {
    this.setState({ isDeleteModalOpen: !this.state.isDeleteModalOpen })
  }

  renderDeleteConfirmation = () => {
    const { isDeleteModalOpen, deleteQuestionId, deleteReplyId } = this.state

    return (
      <Modal light isModalOpen={isDeleteModalOpen}>
        <DeleteCommentryConfirmationModal
          deleteQuestionId={deleteQuestionId}
          deleteReplyId={deleteReplyId}
          toggleModal={this.toggleDeleteModal}
          updateQuestionsList={this.updateQuestionsList}
          updateReplyList={this.updateReplyList}
        />
      </Modal>
    )
  }

  updateQuestionsList = () => {
    const { questions, deleteQuestionId, isDeleteModalOpen } = this.state
    const newQuestions = questions.filter(({ rid }) => rid !== deleteQuestionId)

    this.setState({
      ...this.state,
      questions: newQuestions,
      isDeleteModalOpen: !isDeleteModalOpen
    })
  }

  updateReplyList = (questionId, deleteReplyId) => {
    const { questions } = this.state

    questions.map(question => {
      if (question.rid === questionId) {
        const {replies} = question
        question.replies = replies.filter(({ rid }) => rid !== deleteReplyId)
      }
      return question
    })
    this.setState({
      deleteReplyId: null,
    })
    this.updateQuestions(questions)
  }

  render() {
    const { title, isBankUser } = this.props
    const { questions } = this.state
    const showTitle = !isBankUser ? questions.length > 0 : true

    return ( <Container>
        <Header>
          {showTitle && (
            <Title>{title}</Title>
          )}
          {isBankUser && (
            <AddNewQuestionButton onClick={this.addNewQuestion}>
               + Add new Question
            </AddNewQuestionButton>
          )}
        </Header>
        <div>
          {this.renderQuestions(questions)}
        </div>
        {this.renderDeleteConfirmation()}
      </Container>
    )
  }
}
export { Comment }

export default compose(
  graphql(CreateBankCommentary, {
    name: 'createBankCommentary'
  }),
  graphql(UpdateBankCommentary, {
    name: 'updateBankCommentary'
  }),
  graphql(CreateReply, {
    name: 'createReply'
  }),
  graphql(UpdateReply, {
    name: 'updateReply'
  }),
  withApollo
)(Comment)
